import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "../../lib/api";

export default function OAuthCallback() {
  const { provider } = useParams();
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [msg, setMsg] = useState("Vinculando tu cuenta…");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = sp.get("code");
    const state = sp.get("state");
    const err = sp.get("error_description") || sp.get("error");
    const saved = sessionStorage.getItem(`oauth_state_${provider}`);

    if (err) { setStatus("error"); setMsg(err); return; }
    if (!code) { setStatus("error"); setMsg("No se recibió el código de autorización."); return; }
    if (saved && state && saved !== state) { setStatus("error"); setMsg("Estado de seguridad no válido (posible CSRF)."); return; }

    const redirect_uri = `${window.location.origin}/oauth/${provider}/callback`;
    api.post(`/social/${provider}/exchange`, { code, redirect_uri })
      .then(() => {
        sessionStorage.removeItem(`oauth_state_${provider}`);
        setStatus("ok"); setMsg("¡Cuenta vinculada con éxito!");
        setTimeout(() => navigate("/os/social-connect", { replace: true }), 1200);
      })
      .catch((e) => { setStatus("error"); setMsg(e?.response?.data?.detail || "No se pudo completar la vinculación."); });
  }, [provider, sp, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream" data-testid="oauth-callback">
      <div className="card-surface p-8 max-w-sm text-center">
        {status === "loading" && <Loader2 className="w-8 h-8 animate-spin text-violet mx-auto" />}
        {status === "ok" && <CheckCircle2 className="w-8 h-8 text-violet mx-auto" />}
        {status === "error" && <XCircle className="w-8 h-8 text-destructive mx-auto" />}
        <p className="mt-4 text-sm text-navy/70">{msg}</p>
        {status === "error" && <button onClick={() => navigate("/os/social-connect", { replace: true })} className="btn btn-outline text-sm mt-4">Volver</button>}
      </div>
    </div>
  );
}
